module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhead9-70d185f4633179e89863ee82c6b79a91.jpg";